export const mockPayments = [
  {
    id: 'PY-2025-847291',
    provider: 'Veterans Evaluation Services (VES)',
    providerId: 'PROV-001',
    npi: '1234567890',
    beneficiary: 'BEN-****4521',
    amount: 4850.0,
    procedureCodes: ['99215', '99354', '99355'],
    date: '2025-11-18',
    serviceDate: '2025-11-18',
    submittedDate: '2025-11-19',
    priority: 'HIGH',
    riskScore: 92,
    recommendation: 'REVIEW',
    flagReasons: [
      'Unusual E&M code combination',
      'Amount 3.2x peer average',
      'Prolonged service stacking',
    ],
    auditType: 'Financial',
    region: 'Region 3',
    status: 'Pending',
    vendor: 'Vendor A',
    assignee: 'Sarah Mitchell',
    slaHours: 4,
    slaStatus: 'warning',
  },
  {
    id: 'PY-2025-847156',
    provider: 'OptumServe Health Services (OSHS)',
    providerId: 'PROV-002',
    npi: '2345678901',
    beneficiary: 'BEN-****7832',
    amount: 2340.0,
    procedureCodes: ['99214', '80053'],
    date: '2025-11-17',
    serviceDate: '2025-11-17',
    submittedDate: '2025-11-18',
    priority: 'HIGH',
    riskScore: 78,
    recommendation: 'REVIEW',
    flagReasons: [
      'Provider billing velocity spike (+40%)',
      'Modifier 25 frequency anomaly',
    ],
    auditType: 'Financial',
    region: 'Region 1',
    status: 'Pending',
    vendor: 'Vendor B',
    assignee: 'Sarah Mitchell',
    slaHours: 12,
    slaStatus: 'ok',
  },
  {
    id: 'PY-2025-846998',
    provider: 'Loyal Source Government Services (LSGS)',
    providerId: 'PROV-003',
    npi: '3456789012',
    beneficiary: 'BEN-****2156',
    amount: 892.5,
    procedureCodes: ['MILEAGE-187'],
    date: '2025-11-16',
    serviceDate: '2025-11-16',
    submittedDate: '2025-11-17',
    priority: 'MEDIUM',
    riskScore: 71,
    recommendation: 'REVIEW',
    flagReasons: ['Mileage exceeds 200mi threshold', 'Route verification needed'],
    auditType: 'Mileage',
    region: 'Region 5',
    status: 'Pending',
    vendor: 'Vendor A',
    assignee: 'Sarah Mitchell',
    slaHours: 36,
    slaStatus: 'ok',
  },
  {
    id: 'PY-2025-846872',
    provider: 'Leidos QTC Health Services (QTC)',
    providerId: 'PROV-004',
    npi: '4567890123',
    beneficiary: 'BEN-****9043',
    amount: 1650.0,
    procedureCodes: ['99213', '71046'],
    date: '2025-11-15',
    serviceDate: '2025-11-15',
    submittedDate: '2025-11-16',
    priority: 'MEDIUM',
    riskScore: 65,
    recommendation: 'REVIEW',
    flagReasons: ['NCCI edit conflict detected', 'Unbundling pattern match'],
    auditType: 'NCCI Edits',
    region: 'Region 2',
    status: 'Pending',
    vendor: 'Vendor C',
    assignee: 'John Davis',
    slaHours: 48,
    slaStatus: 'ok',
  },
  {
    id: 'PY-2025-846701',
    provider: 'Veterans Evaluation Services (VES)',
    providerId: 'PROV-005',
    npi: '5678901234',
    beneficiary: 'BEN-****3287',
    amount: 3200.0,
    procedureCodes: ['SMOT-4'],
    date: '2025-11-14',
    serviceDate: '2025-11-14',
    submittedDate: '2025-11-15',
    priority: 'MEDIUM',
    riskScore: 58,
    recommendation: 'REVIEW',
    flagReasons: ['Special authorization mismatch', 'Travel type verification'],
    auditType: 'SMOT',
    region: 'Region 4',
    status: 'Pending',
    vendor: 'Vendor B',
    assignee: null,
    slaHours: 72,
    slaStatus: 'ok',
  },
  {
    id: 'PY-2025-846589',
    provider: 'OptumServe Health Services (OSHS)',
    providerId: 'PROV-006',
    npi: '6789012345',
    beneficiary: 'BEN-****6721',
    amount: 425.0,
    procedureCodes: ['99212'],
    date: '2025-11-14',
    serviceDate: '2025-11-14',
    submittedDate: '2025-11-14',
    priority: 'LOW',
    riskScore: 42,
    recommendation: 'AUTO-APPROVE',
    flagReasons: ['Minor statistical deviation'],
    auditType: 'Financial',
    region: 'Region 1',
    status: 'Pending',
    vendor: 'Vendor A',
    assignee: 'Sarah Mitchell',
    slaHours: 96,
    slaStatus: 'ok',
  },
  {
    id: 'PY-2025-846445',
    provider: 'Loyal Source Government Services (LSGS)',
    providerId: 'PROV-007',
    npi: '7890123456',
    beneficiary: 'BEN-****1098',
    amount: 1890.0,
    procedureCodes: ['MILEAGE-245'],
    date: '2025-11-13',
    serviceDate: '2025-11-13',
    submittedDate: '2025-11-13',
    priority: 'MEDIUM',
    riskScore: 68,
    recommendation: 'REVIEW',
    flagReasons: ['Route verification needed', 'Non-specialty over 200mi'],
    auditType: 'Mileage',
    region: 'Region 6',
    status: 'Pending',
    vendor: 'Vendor D',
    assignee: 'Emily Chen',
    slaHours: 24,
    slaStatus: 'ok',
  },
  {
    id: 'PY-2025-846302',
    provider: 'Leidos QTC Health Services (QTC)',
    providerId: 'PROV-008',
    npi: '8901234567',
    beneficiary: 'BEN-****5544',
    amount: 2100.0,
    procedureCodes: ['99215', '99354'],
    date: '2025-11-12',
    serviceDate: '2025-11-12',
    submittedDate: '2025-11-12',
    priority: 'HIGH',
    riskScore: 75,
    recommendation: 'REVIEW',
    flagReasons: [
      'Prolonged service pattern',
      'Provider on elevated monitoring',
      '4 prior audit findings',
    ],
    auditType: 'Financial',
    region: 'Region 3',
    status: 'Pending',
    vendor: 'Vendor A',
    assignee: null,
    slaHours: 2,
    slaStatus: 'critical',
  },
  {
    id: 'PY-2025-846188',
    provider: 'Loyal Source Government Services (LSGS)',
    providerId: 'PROV-009',
    npi: '9012345678',
    beneficiary: 'BEN-****8877',
    amount: 550.0,
    procedureCodes: ['MILEAGE-95'],
    date: '2025-11-11',
    serviceDate: '2025-11-11',
    submittedDate: '2025-11-11',
    priority: 'LOW',
    riskScore: 45,
    recommendation: 'AUTO-APPROVE',
    flagReasons: ['Mileage 100-200mi non-specialty'],
    auditType: 'Mileage',
    region: 'Region 4',
    status: 'Pending',
    vendor: 'Vendor C',
    assignee: 'John Davis',
    slaHours: 120,
    slaStatus: 'ok',
  },
  {
    id: 'PY-2025-846055',
    provider: 'OptumServe Health Services (OSHS)',
    providerId: 'PROV-010',
    npi: '0123456789',
    beneficiary: 'BEN-****2233',
    amount: 1450.0,
    procedureCodes: ['99214', '90834'],
    date: '2025-11-10',
    serviceDate: '2025-11-10',
    submittedDate: '2025-11-10',
    priority: 'MEDIUM',
    riskScore: 52,
    recommendation: 'REVIEW',
    flagReasons: ['Modifier usage pattern'],
    auditType: 'NCCI Edits',
    region: 'Region 5',
    status: 'Pending',
    vendor: 'Vendor B',
    assignee: 'Sarah Mitchell',
    slaHours: 60,
    slaStatus: 'ok',
  },
];

export const mockProviders = [
  {
    id: 'PROV-001',
    name: 'Veterans Evaluation Services (VES)',
    npi: '1234567890',
    specialty: 'Internal Medicine',
    totalPayments: 145,
    approvalRate: 92.4,
  },
  {
    id: 'PROV-002',
    name: 'OptumServe Health Services (OSHS)',
    npi: '2345678901',
    specialty: 'Multi-Specialty',
    totalPayments: 132,
    approvalRate: 88.6,
  },
  {
    id: 'PROV-003',
    name: 'Loyal Source Government Services (LSGS)',
    npi: '3456789012',
    specialty: 'Family Practice',
    totalPayments: 98,
    approvalRate: 95.2,
  },
  {
    id: 'PROV-004',
    name: 'Leidos QTC Health Services (QTC)',
    npi: '4567890123',
    specialty: 'Multi-Specialty',
    totalPayments: 87,
    approvalRate: 90.1,
  },
];

export const mockUsers = [
  {
    id: '1',
    name: 'Sarah Mitchell',
    email: 'sarah.mitchell@agency.gov',
    role: 'Senior Financial Auditor',
  },
  {
    id: '2',
    name: 'Jane Reviewer',
    email: 'jane@example.com',
    role: 'Payment Reviewer',
  },
];

export const summaryStats = {
  totalPayments: 12847,
  flaggedForReview: 1542,
  highPriority: 287,
  autoApproved: 11018,
  pendingReview: 287,
  reviewedToday: 43,
  savingsIdentified: 847500,
  coverageRate: 100,
};

// ============================================
// QUEUE-SPECIFIC DATA
// ============================================

export const queueStats = {
  myQueue: 47,
  teamQueue: 287,
  unassigned: 34,
  overdueCount: 8,
  dueTodayCount: 23,
  avgProcessingTime: 2.4
};

export const unresolvedItems = [
  {
    id: 'PY-2025-842001',
    provider: 'Veterans Evaluation Services (VES)',
    amount: 1250.0,
    auditType: 'Mileage',
    region: 'Region 2',
    originalDate: '2025-10-15',
    daysOpen: 36,
    status: 'Awaiting Vendor Response',
    lastAction: 'Sent to vendor for documentation'
  },
  {
    id: 'PY-2025-841555',
    provider: 'Leidos QTC Health Services (QTC)',
    amount: 875.0,
    auditType: 'Mileage',
    region: 'Region 4',
    originalDate: '2025-10-22',
    daysOpen: 29,
    status: 'Under Investigation',
    lastAction: 'Referred to compliance team'
  }
];

// ============================================
// DETAILED MOCK DATA FOR CASE DETAIL VIEWS
// ============================================

export const detailedCaseData = {
  // ============================================
  // CASE 1: Veterans Evaluation Services (Financial)
  // ============================================
  'PY-2025-847291': {
    id: 'PY-2025-847291',
    provider: {
      name: 'Veterans Evaluation Services (VES)',
      npi: '1234567890',
      specialty: 'Internal Medicine',
      address: '1234 Medical Center Dr, Richmond, VA 23220',
      yearsInPractice: 12,
      totalClaims: 4521,
      priorAuditFindings: 3,
      riskTier: 'Elevated'
    },
    beneficiary: {
      id: 'BEN-****4521',
      ageRange: '65-74',
      region: 'Region 3'
    },
    payment: {
      amount: 4850.0,
      requestedAmount: 4850.0,
      allowedAmount: 2150.0,
      serviceDate: '2025-11-18',
      submissionDate: '2025-11-19',
      placeOfService: '11 - Office',
      procedureCodes: [
        { code: '99215', description: 'Office visit, established patient, high complexity', amount: 250.0, flagged: true },
        { code: '99354', description: 'Prolonged service, first hour', amount: 2300.0, flagged: true },
        { code: '99355', description: 'Prolonged service, additional 30 min', amount: 2300.0, flagged: true }
      ],
      diagnosisCodes: ['E11.9', 'I10', 'E78.5'],
      modifiers: ['25']
    },
    riskScore: 92,
    priority: 'HIGH',
    auditType: 'Financial',
    region: 'Region 3',
    vendor: 'Vendor A',
    slaHours: 4,
    slaStatus: 'warning',
    aiAnalysis: {
      summary: 'This payment is flagged for review due to an unusual combination of prolonged service codes with a high-complexity E&M visit. The total amount is 3.2x higher than peer average for similar service patterns. The provider has 3 prior audit findings related to upcoding.',
      confidence: 0.89,
      ruleViolations: [
        { ruleId: 'R-305', ruleName: 'Prolonged Service Stacking', severity: 'HIGH', description: 'Multiple prolonged service codes billed with high-complexity E&M on same date. Medical documentation must support extended face-to-face time.' },
        { ruleId: 'R-118', ruleName: 'Amount Threshold Exceeded', severity: 'MEDIUM', description: 'Payment amount exceeds 3x peer average for similar service patterns in the same specialty and region.' }
      ],
      statisticalAnomalies: [
        { metric: 'Peer Comparison', value: '$4,850 vs $1,516 peer avg', percentile: 98, stdDev: 3.2 },
        { metric: 'Provider Trend', value: '23% prolonged service frequency', baseline: '8%', change: '+187% over 90 days' },
        { metric: 'Billing Velocity', value: '127 claims/week', baseline: '89', change: '+43% over 30 days' }
      ],
      mlFeatures: [
        { feature: 'prolonged_service_ratio', contribution: 0.28, direction: 'risk', description: 'High ratio of prolonged services to total claims' },
        { feature: 'peer_amount_deviation', contribution: 0.24, direction: 'risk', description: 'Payment significantly above peer average' },
        { feature: 'billing_velocity_change', contribution: 0.18, direction: 'risk', description: 'Recent increase in billing frequency' },
        { feature: 'modifier_25_frequency', contribution: 0.12, direction: 'risk', description: 'Elevated use of modifier 25' },
        { feature: 'code_combination_rarity', contribution: 0.08, direction: 'risk', description: 'Unusual procedure code combination' }
      ]
    },
    providerHistory: {
      recentClaims: [
        { date: '2025-11-15', amount: 3200.0, codes: ['99215', '99354'], status: 'Paid', beneficiary: 'BEN-****7721' },
        { date: '2025-11-12', amount: 4100.0, codes: ['99214', '99354', '99355'], status: 'Under Review', beneficiary: 'BEN-****3382' },
        { date: '2025-11-08', amount: 2800.0, codes: ['99215', '99354'], status: 'Paid', beneficiary: 'BEN-****9914' },
        { date: '2025-11-05', amount: 1950.0, codes: ['99214', '99354'], status: 'Paid', beneficiary: 'BEN-****2207' },
        { date: '2025-11-01', amount: 3600.0, codes: ['99215', '99354', '99355'], status: 'Paid', beneficiary: 'BEN-****8845' }
      ],
      auditHistory: [
        { date: '2024-08-15', finding: 'Upcoding - E&M Level', amount: 1250.0, resolution: 'Refund Collected', caseId: 'AUD-2024-1847' },
        { date: '2023-11-20', finding: 'Documentation Insufficient', amount: 890.0, resolution: 'Refund Collected', caseId: 'AUD-2023-9221' },
        { date: '2023-03-08', finding: 'Duplicate Billing', amount: 445.0, resolution: 'Refund Collected', caseId: 'AUD-2023-2104' }
      ],
      metrics: {
        totalPaidYTD: 487500,
        claimsYTD: 1247,
        denialRate: 4.2,
        averagePerClaim: 391,
        peerAveragePerClaim: 285
      }
    },
    similarCases: [
      { id: 'PY-2025-832145', provider: 'Leidos QTC Health Services (QTC)', amount: 4200.0, riskScore: 88, decision: 'DENIED', finding: 'Medical necessity not supported for prolonged services' },
      { id: 'PY-2025-819876', provider: 'OptumServe Health Services (OSHS)', amount: 3950.0, riskScore: 85, decision: 'APPROVED', finding: 'Documentation verified - complex patient with multiple comorbidities' },
      { id: 'PY-2025-807234', provider: 'Loyal Source Government Services (LSGS)', amount: 4100.0, riskScore: 82, decision: 'DENIED', finding: 'Insufficient documentation for 99355' }
    ]
  },

  // ============================================
  // CASE 2: OptumServe Health Services (Financial)
  // ============================================
  'PY-2025-847156': {
    id: 'PY-2025-847156',
    provider: {
      name: 'OptumServe Health Services (OSHS)',
      npi: '2345678901',
      specialty: 'Cardiology',
      address: '567 Heart Center Blvd, Chicago, IL 60601',
      yearsInPractice: 18,
      totalClaims: 6234,
      priorAuditFindings: 1,
      riskTier: 'Moderate'
    },
    beneficiary: {
      id: 'BEN-****7832',
      ageRange: '75-84',
      region: 'Region 1'
    },
    payment: {
      amount: 2340.0,
      requestedAmount: 2340.0,
      allowedAmount: 1890.0,
      serviceDate: '2025-11-17',
      submissionDate: '2025-11-18',
      placeOfService: '11 - Office',
      procedureCodes: [
        { code: '99214', description: 'Office visit, established patient, moderate complexity', amount: 180.0, flagged: false },
        { code: '93000', description: 'Electrocardiogram, complete', amount: 85.0, flagged: false },
        { code: '93306', description: 'Echocardiography, complete', amount: 575.0, flagged: true },
        { code: '93320', description: 'Doppler echocardiography', amount: 750.0, flagged: true },
        { code: '93325', description: 'Doppler color flow mapping', amount: 750.0, flagged: true }
      ],
      diagnosisCodes: ['I25.10', 'I48.91', 'R00.0'],
      modifiers: []
    },
    riskScore: 78,
    priority: 'HIGH',
    auditType: 'Financial',
    region: 'Region 1',
    vendor: 'Vendor B',
    slaHours: 12,
    slaStatus: 'ok',
    aiAnalysis: {
      summary: 'This case shows a significant spike in billing velocity from this provider over the past 40 days. While the individual services appear clinically appropriate for a cardiology practice, the overall pattern suggests potential over-utilization of echo services. The provider\'s modifier 25 usage has also increased substantially.',
      confidence: 0.76,
      ruleViolations: [
        { ruleId: 'R-201', ruleName: 'Billing Velocity Anomaly', severity: 'HIGH', description: 'Provider billing volume has increased 40% over the past 30 days with no corresponding change in patient panel size.' },
        { ruleId: 'R-156', ruleName: 'Modifier 25 Frequency', severity: 'MEDIUM', description: 'Modifier 25 usage rate is 2.3x peer average for this specialty.' }
      ],
      statisticalAnomalies: [
        { metric: 'Billing Velocity', value: '156 claims/week', baseline: '112', change: '+40% over 30 days' },
        { metric: 'Echo Utilization', value: '78% of visits include echo', baseline: '45%', change: '+73% vs peer' },
        { metric: 'Revenue per Visit', value: '$487 avg', baseline: '$312 peer avg', change: '+56%' }
      ],
      mlFeatures: [
        { feature: 'billing_velocity_change', contribution: 0.32, direction: 'risk', description: 'Rapid increase in claim submission rate' },
        { feature: 'echo_utilization_rate', contribution: 0.26, direction: 'risk', description: 'High rate of echo services per visit' },
        { feature: 'modifier_25_frequency', contribution: 0.18, direction: 'risk', description: 'Elevated separate E&M billing' },
        { feature: 'revenue_per_visit', contribution: 0.14, direction: 'risk', description: 'Above-average revenue per encounter' },
        { feature: 'prior_audit_clean', contribution: 0.10, direction: 'protective', description: 'Limited prior audit findings' }
      ]
    },
    providerHistory: {
      recentClaims: [
        { date: '2025-11-15', amount: 2100.0, codes: ['99214', '93306', '93320'], status: 'Paid', beneficiary: 'BEN-****4411' },
        { date: '2025-11-14', amount: 2450.0, codes: ['99215', '93306', '93320', '93325'], status: 'Paid', beneficiary: 'BEN-****8823' },
        { date: '2025-11-13', amount: 1890.0, codes: ['99214', '93000', '93306'], status: 'Paid', beneficiary: 'BEN-****2290' },
        { date: '2025-11-12', amount: 2200.0, codes: ['99214', '93306', '93320', '93325'], status: 'Paid', beneficiary: 'BEN-****7756' },
        { date: '2025-11-11', amount: 2340.0, codes: ['99214', '93306', '93320', '93325'], status: 'Paid', beneficiary: 'BEN-****3344' }
      ],
      auditHistory: [
        { date: '2024-02-10', finding: 'Documentation Insufficient', amount: 650.0, resolution: 'Refund Collected', caseId: 'AUD-2024-0892' }
      ],
      metrics: {
        totalPaidYTD: 892000,
        claimsYTD: 1832,
        denialRate: 2.8,
        averagePerClaim: 487,
        peerAveragePerClaim: 312
      }
    },
    similarCases: [
      { id: 'PY-2025-841002', provider: 'Veterans Evaluation Services (VES)', amount: 2150.0, riskScore: 72, decision: 'APPROVED', finding: 'Services supported by documentation' },
      { id: 'PY-2025-838776', provider: 'Leidos QTC Health Services (QTC)', amount: 2680.0, riskScore: 81, decision: 'DENIED', finding: 'Routine echo not medically necessary based on frequency' }
    ]
  },

  // ============================================
  // CASE 3: Loyal Source Government Services (Mileage)
  // ============================================
  'PY-2025-846998': {
    id: 'PY-2025-846998',
    provider: {
      name: 'Loyal Source Government Services (LSGS)',
      npi: '3456789012',
      specialty: 'Transportation Services',
      address: '890 Veterans Way, Phoenix, AZ 85001',
      yearsInPractice: 8,
      totalClaims: 12450,
      priorAuditFindings: 0,
      riskTier: 'Standard'
    },
    beneficiary: {
      id: 'BEN-****2156',
      ageRange: '55-64',
      region: 'Region 5',
      homeAddress: 'Flagstaff, AZ (masked)',
      facilityAddress: 'Phoenix VA Medical Center'
    },
    payment: {
      amount: 892.5,
      requestedAmount: 892.5,
      allowedAmount: 445.0,
      serviceDate: '2025-11-16',
      submissionDate: '2025-11-17',
      placeOfService: '99 - Other',
      procedureCodes: [
        { code: 'MILEAGE-187', description: 'Beneficiary mileage reimbursement - 187 miles one-way', amount: 892.5, flagged: true }
      ],
      diagnosisCodes: ['Z51.11'],
      modifiers: [],
      mileageDetails: {
        oneWayMiles: 187,
        roundTripMiles: 374,
        ratePerMile: 0.67,
        appointmentType: 'Chemotherapy Treatment',
        facilityType: 'VA Medical Center',
        travelDate: '2025-11-16',
        isSpecialty: false
      }
    },
    riskScore: 71,
    priority: 'MEDIUM',
    auditType: 'Mileage',
    region: 'Region 5',
    vendor: 'Vendor A',
    slaHours: 36,
    slaStatus: 'ok',
    aiAnalysis: {
      summary: 'This mileage reimbursement exceeds the 200-mile specialty threshold but the appointment type is listed as non-specialty (chemotherapy is typically considered specialty). The calculated route distance matches the claimed mileage. Verification of specialty classification is recommended.',
      confidence: 0.82,
      ruleViolations: [
        { ruleId: 'M-101', ruleName: 'Mileage Threshold Exceeded', severity: 'MEDIUM', description: 'Claimed mileage of 187 miles exceeds the 100-mile threshold for non-specialty care. If specialty care, 200-mile threshold applies.' },
        { ruleId: 'M-105', ruleName: 'Specialty Classification Review', severity: 'LOW', description: 'Appointment type may qualify as specialty care - recommend verification with VA portal.' }
      ],
      statisticalAnomalies: [
        { metric: 'Distance Verification', value: '187 miles claimed', baseline: '184 miles (Google Maps)', change: '+1.6% variance' },
        { metric: 'Beneficiary Travel Frequency', value: '3 trips this month', baseline: '2.1 avg', change: '+43%' },
        { metric: 'Cost per Trip', value: '$892.50', baseline: '$425 avg for region', change: '+110%' }
      ],
      mlFeatures: [
        { feature: 'distance_threshold_exceeded', contribution: 0.35, direction: 'risk', description: 'Mileage exceeds standard threshold' },
        { feature: 'specialty_classification_unclear', contribution: 0.25, direction: 'risk', description: 'Appointment type classification needs verification' },
        { feature: 'route_distance_match', contribution: 0.20, direction: 'protective', description: 'Claimed distance matches calculated route' },
        { feature: 'beneficiary_history_clean', contribution: 0.15, direction: 'protective', description: 'No prior mileage audit findings for beneficiary' },
        { feature: 'provider_history_clean', contribution: 0.05, direction: 'protective', description: 'Provider has no prior audit findings' }
      ],
      routeVerification: {
        claimedMiles: 187,
        calculatedMiles: 184,
        variance: 1.6,
        varianceAcceptable: true,
        routeSource: 'Google Maps API',
        alternateRoutes: [
          { description: 'Via I-17 S', miles: 184 },
          { description: 'Via US-89 S', miles: 198 }
        ]
      }
    },
    providerHistory: {
      recentClaims: [
        { date: '2025-11-09', amount: 892.5, codes: ['MILEAGE-187'], status: 'Paid', beneficiary: 'BEN-****2156' },
        { date: '2025-11-02', amount: 892.5, codes: ['MILEAGE-187'], status: 'Paid', beneficiary: 'BEN-****2156' },
        { date: '2025-10-28', amount: 445.0, codes: ['MILEAGE-95'], status: 'Paid', beneficiary: 'BEN-****8877' },
        { date: '2025-10-25', amount: 623.0, codes: ['MILEAGE-132'], status: 'Paid', beneficiary: 'BEN-****4432' },
        { date: '2025-10-22', amount: 334.0, codes: ['MILEAGE-71'], status: 'Paid', beneficiary: 'BEN-****9901' }
      ],
      auditHistory: [],
      metrics: {
        totalPaidYTD: 1245000,
        claimsYTD: 12450,
        denialRate: 1.2,
        averagePerClaim: 100,
        peerAveragePerClaim: 95
      }
    },
    similarCases: [
      { id: 'PY-2025-842887', provider: 'OptumServe Health Services (OSHS)', amount: 945.0, riskScore: 68, decision: 'APPROVED', finding: 'Specialty care verified - oncology treatment' },
      { id: 'PY-2025-839221', provider: 'Leidos QTC Health Services (QTC)', amount: 756.0, riskScore: 74, decision: 'DENIED', finding: 'Non-specialty care - closer facility available' },
      { id: 'PY-2025-835544', provider: 'Veterans Evaluation Services (VES)', amount: 890.0, riskScore: 65, decision: 'APPROVED', finding: 'Distance verified, specialty threshold met' }
    ]
  },

  // ============================================
  // CASE 4: Leidos QTC Health Services (NCCI Edits)
  // ============================================
  'PY-2025-846872': {
    id: 'PY-2025-846872',
    provider: {
      name: 'Leidos QTC Health Services (QTC)',
      npi: '4567890123',
      specialty: 'Pulmonology',
      address: '2345 Cascade Medical Plaza, Seattle, WA 98101',
      yearsInPractice: 15,
      totalClaims: 3892,
      priorAuditFindings: 2,
      riskTier: 'Moderate'
    },
    beneficiary: {
      id: 'BEN-****9043',
      ageRange: '65-74',
      region: 'Region 2'
    },
    payment: {
      amount: 1650.0,
      requestedAmount: 1650.0,
      allowedAmount: 890.0,
      serviceDate: '2025-11-15',
      submissionDate: '2025-11-16',
      placeOfService: '11 - Office',
      procedureCodes: [
        { code: '99213', description: 'Office visit, established patient, low complexity', amount: 120.0, flagged: false },
        { code: '71046', description: 'Chest X-ray, 2 views', amount: 95.0, flagged: false },
        { code: '94060', description: 'Bronchodilation responsiveness, spirometry', amount: 185.0, flagged: true },
        { code: '94070', description: 'Bronchospasm provocation evaluation', amount: 450.0, flagged: true },
        { code: '94375', description: 'Respiratory flow volume loop', amount: 250.0, flagged: true },
        { code: '94729', description: 'Diffusing capacity', amount: 550.0, flagged: true }
      ],
      diagnosisCodes: ['J44.1', 'R06.02', 'J45.20'],
      modifiers: ['59']
    },
    riskScore: 65,
    priority: 'MEDIUM',
    auditType: 'NCCI Edits',
    region: 'Region 2',
    vendor: 'Vendor C',
    slaHours: 48,
    slaStatus: 'ok',
    aiAnalysis: {
      summary: 'Multiple pulmonary function tests billed together trigger NCCI edit review. Codes 94060 and 94070 are commonly bundled and typically require modifier 59 with supporting documentation. The combination of 4 PFT codes on a single date is unusual but may be clinically appropriate for comprehensive pulmonary evaluation.',
      confidence: 0.71,
      ruleViolations: [
        { ruleId: 'N-042', ruleName: 'NCCI Column 1/Column 2 Edit', severity: 'MEDIUM', description: 'CPT 94060 and 94070 have an NCCI edit relationship. Modifier 59 applied - verify distinct services.' },
        { ruleId: 'N-088', ruleName: 'Multiple PFT Same Day', severity: 'LOW', description: 'Four pulmonary function tests on same date of service. Verify medical necessity for comprehensive testing.' }
      ],
      statisticalAnomalies: [
        { metric: 'PFT Bundling Rate', value: '4 tests/visit', baseline: '2.1 avg', change: '+90%' },
        { metric: 'Modifier 59 Usage', value: '34% of claims', baseline: '18% peer avg', change: '+89%' },
        { metric: 'Revenue per PFT Visit', value: '$1,650', baseline: '$890 avg', change: '+85%' }
      ],
      mlFeatures: [
        { feature: 'ncci_edit_triggered', contribution: 0.30, direction: 'risk', description: 'NCCI edit relationship between billed codes' },
        { feature: 'modifier_59_frequency', contribution: 0.22, direction: 'risk', description: 'Higher than average modifier 59 usage' },
        { feature: 'pft_bundling_rate', contribution: 0.20, direction: 'risk', description: 'Multiple PFTs billed together' },
        { feature: 'diagnosis_supports_testing', contribution: 0.18, direction: 'protective', description: 'COPD/asthma diagnoses support comprehensive PFT' },
        { feature: 'specialty_appropriate', contribution: 0.10, direction: 'protective', description: 'Pulmonology specialty appropriate for services' }
      ],
      ncciEditDetails: {
        editPairs: [
          { column1: '94060', column2: '94070', modifier: '59', allowed: true, documentation: 'Requires documentation of distinct service' },
          { column1: '94375', column2: '94729', modifier: null, allowed: true, documentation: 'No edit - separate services' }
        ],
        recommendation: 'Review documentation to verify 94060 and 94070 were performed as distinct services at different times or on different anatomical sites.'
      }
    },
    providerHistory: {
      recentClaims: [
        { date: '2025-11-12', amount: 1450.0, codes: ['99214', '94060', '94375', '94729'], status: 'Paid', beneficiary: 'BEN-****7712' },
        { date: '2025-11-10', amount: 1890.0, codes: ['99215', '94060', '94070', '94375', '94729'], status: 'Paid', beneficiary: 'BEN-****3321' },
        { date: '2025-11-08', amount: 980.0, codes: ['99213', '94060', '94375'], status: 'Paid', beneficiary: 'BEN-****8899' },
        { date: '2025-11-05', amount: 1650.0, codes: ['99214', '94060', '94070', '94375'], status: 'Paid', beneficiary: 'BEN-****2244' },
        { date: '2025-11-01', amount: 1320.0, codes: ['99213', '94060', '94375', '94729'], status: 'Paid', beneficiary: 'BEN-****6677' }
      ],
      auditHistory: [
        { date: '2024-05-18', finding: 'NCCI Edit - Unbundling', amount: 450.0, resolution: 'Refund Collected', caseId: 'AUD-2024-4521' },
        { date: '2023-09-22', finding: 'Modifier 59 Misuse', amount: 380.0, resolution: 'Refund Collected', caseId: 'AUD-2023-7845' }
      ],
      metrics: {
        totalPaidYTD: 562000,
        claimsYTD: 3892,
        denialRate: 5.1,
        averagePerClaim: 144,
        peerAveragePerClaim: 112
      }
    },
    similarCases: [
      { id: 'PY-2025-840123', provider: 'Veterans Evaluation Services (VES)', amount: 1420.0, riskScore: 62, decision: 'APPROVED', finding: 'Documentation supported distinct PFT services' },
      { id: 'PY-2025-837665', provider: 'Loyal Source Government Services (LSGS)', amount: 1780.0, riskScore: 71, decision: 'DENIED', finding: 'Modifier 59 not supported - same service session' },
      { id: 'PY-2025-834221', provider: 'OptumServe Health Services (OSHS)', amount: 1550.0, riskScore: 58, decision: 'APPROVED', finding: 'Comprehensive PFT medically necessary for new COPD diagnosis' }
    ]
  },

  // ============================================
  // CASE 5: Veterans Evaluation Services (SMOT)
  // ============================================
  'PY-2025-846701': {
    id: 'PY-2025-846701',
    provider: {
      name: 'Veterans Evaluation Services (VES)',
      npi: '5678901234',
      specialty: 'Orthopedic Surgery',
      address: '678 Orthopedic Center Dr, Atlanta, GA 30301',
      yearsInPractice: 22,
      totalClaims: 2156,
      priorAuditFindings: 1,
      riskTier: 'Standard'
    },
    beneficiary: {
      id: 'BEN-****3287',
      ageRange: '45-54',
      region: 'Region 4'
    },
    payment: {
      amount: 3200.0,
      requestedAmount: 3200.0,
      allowedAmount: 3200.0,
      serviceDate: '2025-11-14',
      submissionDate: '2025-11-15',
      placeOfService: '22 - Outpatient Hospital',
      procedureCodes: [
        { code: '27447', description: 'Total knee arthroplasty', amount: 3200.0, flagged: true }
      ],
      diagnosisCodes: ['M17.11', 'Z96.651'],
      modifiers: [],
      smotDetails: {
        travelType: 'Type 4 - Surgical',
        authorizationNumber: 'AUTH-2025-87432',
        authorizationDate: '2025-10-28',
        authorizedProcedure: 'Total knee replacement - right',
        authorizedAmount: 3500.0,
        preAuthRequired: true,
        preAuthStatus: 'Approved',
        specialModeOfTravel: true,
        transportationType: 'Ambulatory - Special Assistance Required'
      }
    },
    riskScore: 58,
    priority: 'MEDIUM',
    auditType: 'SMOT',
    region: 'Region 4',
    vendor: 'Vendor B',
    slaHours: 72,
    slaStatus: 'ok',
    aiAnalysis: {
      summary: 'This SMOT (Special Mode of Travel) case involves a Type 4 surgical procedure with pre-authorization. The authorization number on file shows approval for right knee replacement, but the system flagged a potential mismatch with the beneficiary\'s travel records. Verification of authorization alignment is recommended.',
      confidence: 0.68,
      ruleViolations: [
        { ruleId: 'S-201', ruleName: 'Authorization Verification Required', severity: 'MEDIUM', description: 'Travel Type 4 requires authorization verification. Authorization AUTH-2025-87432 on file but travel records show potential date discrepancy.' },
        { ruleId: 'S-105', ruleName: 'SMOT Travel Documentation', severity: 'LOW', description: 'Special mode of travel claimed - verify transportation arrangement matches authorization.' }
      ],
      statisticalAnomalies: [
        { metric: 'Authorization Match', value: 'Partial match', baseline: 'Full match expected', change: 'Date variance detected' },
        { metric: 'Procedure Cost', value: '$3,200', baseline: '$3,150 regional avg', change: '+1.6%' },
        { metric: 'Pre-Auth Compliance', value: '94%', baseline: '97% provider avg', change: '-3%' }
      ],
      mlFeatures: [
        { feature: 'auth_date_variance', contribution: 0.35, direction: 'risk', description: 'Authorization date does not perfectly align with service date' },
        { feature: 'smot_type_4_flag', contribution: 0.25, direction: 'neutral', description: 'Type 4 travel requires enhanced review' },
        { feature: 'amount_within_auth', contribution: 0.20, direction: 'protective', description: 'Billed amount within authorized limit' },
        { feature: 'provider_compliance_history', contribution: 0.15, direction: 'protective', description: 'Provider has good compliance history' },
        { feature: 'procedure_code_match', contribution: 0.05, direction: 'protective', description: 'Procedure matches authorization' }
      ],
      authorizationVerification: {
        authNumber: 'AUTH-2025-87432',
        authDate: '2025-10-28',
        serviceDate: '2025-11-14',
        daysBetween: 17,
        maxAllowedDays: 30,
        withinWindow: true,
        authorizedProcedure: '27447 - Total knee arthroplasty',
        billedProcedure: '27447 - Total knee arthroplasty',
        procedureMatch: true,
        authorizedAmount: 3500.0,
        billedAmount: 3200.0,
        amountWithinLimit: true,
        flagReason: 'Travel date in system shows 2025-11-13, service date shows 2025-11-14'
      }
    },
    providerHistory: {
      recentClaims: [
        { date: '2025-11-10', amount: 3150.0, codes: ['27447'], status: 'Paid', beneficiary: 'BEN-****5521' },
        { date: '2025-11-07', amount: 2890.0, codes: ['27446'], status: 'Paid', beneficiary: 'BEN-****8834' },
        { date: '2025-11-03', amount: 3200.0, codes: ['27447'], status: 'Paid', beneficiary: 'BEN-****2267' },
        { date: '2025-10-29', amount: 4500.0, codes: ['27447', '20610'], status: 'Paid', beneficiary: 'BEN-****9910' },
        { date: '2025-10-25', amount: 3100.0, codes: ['27447'], status: 'Paid', beneficiary: 'BEN-****4456' }
      ],
      auditHistory: [
        { date: '2024-01-15', finding: 'Authorization Date Mismatch', amount: 0.0, resolution: 'Documentation Corrected - No Refund', caseId: 'AUD-2024-0234' }
      ],
      metrics: {
        totalPaidYTD: 1890000,
        claimsYTD: 2156,
        denialRate: 2.1,
        averagePerClaim: 877,
        peerAveragePerClaim: 845
      }
    },
    similarCases: [
      { id: 'PY-2025-838901', provider: 'Leidos QTC Health Services (QTC)', amount: 3400.0, riskScore: 52, decision: 'APPROVED', finding: 'Authorization verified - date variance within acceptable range' },
      { id: 'PY-2025-835443', provider: 'OptumServe Health Services (OSHS)', amount: 3100.0, riskScore: 61, decision: 'APPROVED', finding: 'Travel documentation confirmed' },
      { id: 'PY-2025-832110', provider: 'Loyal Source Government Services (LSGS)', amount: 3550.0, riskScore: 67, decision: 'DENIED', finding: 'Authorization expired at time of service' }
    ]
  },

  // ============================================
  // CASE 6: Leidos QTC Health Services (Financial - Critical SLA)
  // ============================================
  'PY-2025-846302': {
    id: 'PY-2025-846302',
    provider: {
      name: 'Leidos QTC Health Services (QTC)',
      npi: '8901234567',
      specialty: 'Internal Medicine',
      address: '321 Oceanview Medical Center, Virginia Beach, VA 23451',
      yearsInPractice: 9,
      totalClaims: 2891,
      priorAuditFindings: 4,
      riskTier: 'High'
    },
    beneficiary: {
      id: 'BEN-****5544',
      ageRange: '75-84',
      region: 'Region 3'
    },
    payment: {
      amount: 2100.0,
      requestedAmount: 2100.0,
      allowedAmount: 850.0,
      serviceDate: '2025-11-12',
      submissionDate: '2025-11-12',
      placeOfService: '11 - Office',
      procedureCodes: [
        { code: '99215', description: 'Office visit, established patient, high complexity', amount: 250.0, flagged: true },
        { code: '99354', description: 'Prolonged service, first hour', amount: 1850.0, flagged: true }
      ],
      diagnosisCodes: ['E11.65', 'I10', 'N18.3', 'E78.0'],
      modifiers: ['25']
    },
    riskScore: 75,
    priority: 'HIGH',
    auditType: 'Financial',
    region: 'Region 3',
    vendor: 'Vendor A',
    slaHours: 2,
    slaStatus: 'critical',
    aiAnalysis: {
      summary: 'URGENT: This provider has 4 prior audit findings and is currently on an elevated monitoring tier. This claim shows the same prolonged service pattern that resulted in previous refund actions. The provider\'s prolonged service utilization rate is 340% above peer average. Immediate review recommended.',
      confidence: 0.91,
      ruleViolations: [
        { ruleId: 'R-305', ruleName: 'Prolonged Service Pattern', severity: 'HIGH', description: 'Provider shows repeated pattern of prolonged service billing that has previously resulted in audit findings.' },
        { ruleId: 'R-401', ruleName: 'Elevated Monitoring Trigger', severity: 'HIGH', description: 'Provider is on elevated monitoring tier due to prior audit history. All prolonged service claims require manual review.' },
        { ruleId: 'R-118', ruleName: 'Amount Threshold Exceeded', severity: 'MEDIUM', description: 'Payment amount exceeds 2.5x peer average.' }
      ],
      statisticalAnomalies: [
        { metric: 'Prolonged Service Rate', value: '44% of E&M visits', baseline: '10% peer avg', change: '+340%' },
        { metric: 'Prior Audit Findings', value: '4 findings', baseline: '0.8 avg', change: '+400%' },
        { metric: 'Revenue per Visit', value: '$2,100', baseline: '$285 peer avg', change: '+637%' }
      ],
      mlFeatures: [
        { feature: 'prior_audit_findings', contribution: 0.35, direction: 'risk', description: 'Multiple prior audit findings on record' },
        { feature: 'prolonged_service_pattern', contribution: 0.28, direction: 'risk', description: 'Repeated prolonged service billing pattern' },
        { feature: 'elevated_monitoring_tier', contribution: 0.20, direction: 'risk', description: 'Provider on enhanced monitoring' },
        { feature: 'peer_amount_deviation', contribution: 0.12, direction: 'risk', description: 'Significantly above peer average' },
        { feature: 'complex_patient_diagnoses', contribution: 0.05, direction: 'protective', description: 'Multiple chronic conditions documented' }
      ]
    },
    providerHistory: {
      recentClaims: [
        { date: '2025-11-10', amount: 2100.0, codes: ['99215', '99354'], status: 'Paid', beneficiary: 'BEN-****7788' },
        { date: '2025-11-08', amount: 1950.0, codes: ['99214', '99354'], status: 'Under Review', beneficiary: 'BEN-****3322' },
        { date: '2025-11-06', amount: 2100.0, codes: ['99215', '99354'], status: 'Paid', beneficiary: 'BEN-****9911' },
        { date: '2025-11-04', amount: 2100.0, codes: ['99215', '99354'], status: 'Paid', beneficiary: 'BEN-****4455' },
        { date: '2025-11-01', amount: 1850.0, codes: ['99214', '99354'], status: 'Paid', beneficiary: 'BEN-****6677' }
      ],
      auditHistory: [
        { date: '2025-06-20', finding: 'Upcoding - Prolonged Service', amount: 2450.0, resolution: 'Refund Collected', caseId: 'AUD-2025-3421' },
        { date: '2025-02-14', finding: 'Upcoding - E&M Level', amount: 1890.0, resolution: 'Refund Collected', caseId: 'AUD-2025-0892' },
        { date: '2024-09-08', finding: 'Documentation Insufficient', amount: 1250.0, resolution: 'Refund Collected', caseId: 'AUD-2024-7234' },
        { date: '2024-04-22', finding: 'Upcoding - Prolonged Service', amount: 3100.0, resolution: 'Refund Collected', caseId: 'AUD-2024-2891' }
      ],
      metrics: {
        totalPaidYTD: 445000,
        claimsYTD: 2891,
        denialRate: 8.7,
        averagePerClaim: 154,
        peerAveragePerClaim: 95
      }
    },
    similarCases: [
      { id: 'PY-2025-845001', provider: 'Leidos QTC Health Services (QTC)', amount: 2100.0, riskScore: 78, decision: 'DENIED', finding: 'Same provider - documentation did not support prolonged service' },
      { id: 'PY-2025-843221', provider: 'Leidos QTC Health Services (QTC)', amount: 1950.0, riskScore: 72, decision: 'DENIED', finding: 'Same provider - upcoding confirmed' },
      { id: 'PY-2025-841109', provider: 'Veterans Evaluation Services (VES)', amount: 1890.0, riskScore: 68, decision: 'APPROVED', finding: 'Different provider - documentation verified complex case' }
    ]
  }
};

// ============================================
// HELPER FUNCTION TO GET CASE BY ID
// ============================================

export const getCaseById = (caseId) => {
  return detailedCaseData[caseId] || null;
};

// ============================================
// LIST OF ALL CASE IDS WITH SUMMARY INFO
// ============================================

export const caseIndex = [
  { id: 'PY-2025-847291', provider: 'Veterans Evaluation Services (VES)', auditType: 'Financial', riskScore: 92, priority: 'HIGH' },
  { id: 'PY-2025-847156', provider: 'OptumServe Health Services (OSHS)', auditType: 'Financial', riskScore: 78, priority: 'HIGH' },
  { id: 'PY-2025-846998', provider: 'Loyal Source Government Services (LSGS)', auditType: 'Mileage', riskScore: 71, priority: 'MEDIUM' },
  { id: 'PY-2025-846872', provider: 'Leidos QTC Health Services (QTC)', auditType: 'NCCI Edits', riskScore: 65, priority: 'MEDIUM' },
  { id: 'PY-2025-846701', provider: 'Veterans Evaluation Services (VES)', auditType: 'SMOT', riskScore: 58, priority: 'MEDIUM' },
  { id: 'PY-2025-846302', provider: 'Leidos QTC Health Services (QTC)', auditType: 'Financial', riskScore: 75, priority: 'HIGH' }
];
